import Srcset from '@/components/common/Srcset';
import NoOrder from './NoOrder';
import OrderComponent from '../../Order/OrderComponent';
import { showPwaLoader } from '@/redux/actions/pwaAction';


const OrderList = (props) => {
  const { styles,noOfOrders } = props;
  const noOrder = props.noOrder;
  const ordersList = props.ordersList;

  if(noOrder) {
    return <NoOrder styles={styles} activeTab={props.activeTab} setAccountSidebarOpen={props.setAccountSidebarOpen}
    />
  }
  if(ordersList && ordersList.length) {
    let order_label = ordersList.length ==1? '1 order':noOfOrders+' orders';
    return (
      <div className={`${styles.account_card}`}>
        
        <div className={`${styles.account_back}`}>
          <a  onClick={() => {props.activeTab('')}}>
            <Srcset
              requirePath={true}
              svgFile={true}
              className={'back_icon'}
              src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
              alt="back button"
              height="16"
              width="19.11"
              tabIndex={0}
            />
          </a>
          <Srcset
            onClick={() => {props.setAccountSidebarOpen(false);props.activeTab('')}}
            requirePath={true}
            svgFile={true}
            className={'close_icon_account_tab'}
            src={"images/Icons/Cross/Large.svg"}
            alt="cloe button"
            height="16"
            width="19.11"
          />
        </div>
        <div className={`${styles.card_head}`}>
          <div className={`x-large-xs xx-large-sm xx-large-md light ${styles.card_title}`}>Your Orders</div>
          <div className={`xx-small-xs small-sm small-md ${styles.card_action}`}>{order_label}</div>
        </div>
        <div className={`${styles.card_footer} ${styles.orders_card} button_footer`}>
          <div className={`${styles.return_cta}`}>
           <a className='btn btn-primary' target="_blank" rel="noopener noreferrer" href={`${process.env.LOOPRETURNS_STORE_DOMAIN}`} onClick={() => { dispatch(showPwaLoader(true));window?.ReactNativeWebView?.postMessage(JSON.stringify({ externalLink:true, link : `${process.env.LOOPRETURNS_STORE_DOMAIN}`}))}}>Create return or exchange</a>
          </div>
        </div>
        <div className={`${styles.card_body}`}>
         {ordersList.length && <OrderComponent styles={styles} ordersList={ordersList} activeTab={props.activeTab} setActiveOrder={props.setActiveOrder} />}
        </div>
      </div>
    )
  }
  return (
    <div className={`${styles.account_card}`}>
      <div className={`${styles.account_back}`}>
        <a  onClick={() => {props.activeTab('')}}>
          <Srcset
            requirePath={true}
            svgFile={true}
            className={'back_icon'}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="16"
            width="19.11"
            tabIndex={0}
          />
        </a>
      </div>
      <div className={`${styles.card_head} ${styles.no_order}`}>
        <div className={`x-large-xs large-sm x-large-md light ${styles.card_title}`}>Your Orders</div>
        <div className={`${styles.card_action}`}>{ordersList.length} order{ordersList.length !== 1 && 's'}</div>
      </div>
      <div className={`${styles.card_body}`}>
       {ordersList.length ? <OrderComponent styles={styles} ordersList={ordersList} activeTab={props.activeTab} activeOrder={props.activeOrder} /> : ''}
        <div className={`${styles.card_action}`}></div>
      </div>
    </div>
  )
}

export default OrderList